import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import Typography from '@material-ui/core/Typography';
import logo from "assets/img/iran_itex.jpg";
import Paper from '@material-ui/core/Paper';
import Axios from "axios";
import Config from "../../../config.js"
import swal from 'sweetalert'
import Checkbox from '@material-ui/core/Checkbox';
import BeatLoader from "react-spinners/BeatLoader";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import styles from "assets/jss/material-kit-react/views/expositionPage.js";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(styles);

export default function ProfilePage(props) {
  let [loading, setLoading] = useState(true);
  let [totalPrice, setTotalPrice] = useState(0);
  let [chooseProduct, setChooseProduct] = useState(0);
  let [goldValid, setGoldValid] = useState(true);
  let [offCode, setOffCode] = useState("");
  const classes = useStyles();
  const { ...rest } = props;
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  const handleTextBoxChange = (event) => {
    setOffCode(event.target.value);
  };
  const [products, setProducts] = useState(null);
  const [state, setState] = React.useState({
    iranitex: true,
    itweekend: false,
    startuptalent: false,
    classes: false,
    class1: false,
    class2: false,
    class3: false,
    class4: false,
    class5: false,
    class6: false,
    class7: false,
    class8: false,
    gold: false
  });
  function Scroll() {
    var elmnt = document.getElementById("registerList");
    elmnt.scrollIntoView();
  }
  function Go() {
    swal("در حال انتقال", {
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: false,
      allowOutsideClick: false
    })

    Axios.post(Config.api + "Product/Buy/Start", {
      productIds: ["5ffcde0ea50731301591cf3c"],
      redirectUrl: "Expositions/ZarinPal/Verify",
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')

        }
      }).then((result) => {
       // return swal("رویداد از 25 بهمن آغاز خواهد شد، لطفا در زمان مقرر مراجعه فرمایید.")
        window.location.href = "/Expositions/Main/";
      }).catch(err => {
        console.log(err)
        if (err && err.response && err.response.status && err.response.status === 401) {
          localStorage.removeItem('token');
          props.history.push("/SignIn");
        }
        else if (err && err.response && err.response.status && err.response.status === 422)
          swal("اطلاعات ارسالی نادرست است.");
        else if (err && err.response && err.response.status && err.response.status === 409) {
          swal("اطلاعات ارسالی نادرست است.");
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })

  }
  function PayAndGo() {

    swal("در حال انتقال به بانک", {
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: false,
      allowOutsideClick: false
    })

    var chooses = chooseProduct.map(function (item) {
      return item['_id'].toString();
    });
    console.log(chooses)
    var data = {
      productIds: chooses,
      redirectUrl: "Expositions/ZarinPal/Verify",
    };
    if (offCode)
      data.offCode = offCode;

    Axios.post(Config.api + "Product/Buy/Start", data,
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')

        }
      }).then((result) => {
        swal("مبلغ قابل پرداخت : " + result.data.data.Total + " تومان", {
          button: {
            text: "پرداخت"
          },
        }).then(() => {
          window.location.href = (result.data.data.Url)
        })
      }).catch(err => {
        console.log(err)
        if (err && err.response && err.response.status && err.response.status === 401) {
          localStorage.removeItem('token');
          props.history.push("/SignIn");
        }
        else if (err && err.response && err.response.status && err.response.status === 422)
          swal("اطلاعات ارسالی نادرست است.");
        else if (err && err.response && err.response.status && err.response.status === 409) {
          swal("اطلاعات ارسالی نادرست است.");
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })
  }
  function handleCheckBox(e) {
    var c = e.target.checked
    var s = state;
    if (e.target.name == "itweekend") {
      s.itweekend = c;
    }
    if (e.target.name == "startuptalent") {
      s.startuptalent = c;
    }
    if (e.target.name == "class1") {
      s.class1 = c;
    }
    if (e.target.name == "class2") {
      s.class2 = c;
    }
    if (e.target.name == "class3") {
      s.class3 = c;
    }
    if (e.target.name == "class4") {
      s.class4 = c;
    }
    if (e.target.name == "class5") {
      s.class5 = c;
    }
    if (e.target.name == "class6") {
      s.class6 = c;
    }
    if (e.target.name == "class7") {
      s.class7 = c;
    }
    if (e.target.name == "class8") {
      s.class8 = c;
    }

    if (e.target.name == "classes") {
      if (!products[4].bought)
        s.class1 = c;
      if (!products[5].bought)
        s.class2 = c;
      if (!products[6].bought)
        s.class3 = c;
      if (!products[7].bought)
        s.class4 = c;
      if (!products[8].bought)
        s.class5 = c;
      if (!products[9].bought)
        s.class6 = c;
      if (!products[10].bought)
        s.class7 = c;
      if (!products[11].bought)
        s.class8 = c;
      s.classes = c;
    }
    if (s.class1 && s.class2 && s.class3 && s.class4 &&
      s.class5 && s.class6 && s.class7 && s.class8
    )
      s.classes = true
    else {
      s.classes = false
    }
    if (e.target.name == "gold") {
      s.iranitex = true;
      s.startuptalent = true;
      s.itweekend = true;
      s.classes = true;
      s.class1 = true;
      s.class2 = true;
      s.class3 = true;
      s.class4 = true;
      s.class5 = true;
      s.class6 = true;
      s.class7 = true;
      s.class8 = true;
      s.gold = c;
    }
    setState(s);
    var t = 0;
    var p = [];
    if (s.class1 && products[4].bought == false) {
      t += products[4].price;
      p.push(products[4])
    }
    if (s.class2 && products[5].bought == false) {
      t += products[5].price;
      p.push(products[5])
    }
    if (s.class3 && products[6].bought == false) {
      t += products[6].price;
      p.push(products[6])
    }
    if (s.class4 && products[7].bought == false) {
      t += products[7].price;
      p.push(products[7])
    }
    if (s.class5 && products[8].bought == false) {
      t += products[8].price;
      p.push(products[8])
    }
    if (s.class6 && products[9].bought == false) {
      t += products[9].price;
      p.push(products[9])
    }
    if (s.class7 && products[10].bought == false) {
      t += products[10].price;
      p.push(products[10])
    }
    if (s.class8 && products[11].bought == false) {
      t += products[11].price;
      p.push(products[11])
    }
    if (s.iranitex && products[0].bought == false) {
      t += products[0].price;
      p.push(products[0])
    }
    if (s.itweekend && products[1].bought == false) {
      t += products[1].price;
      p.push(products[1])
    }
    if (s.startuptalent && products[2].bought == false) {
      t += products[2].price;
      p.push(products[2])
    }
    if (s.gold && products[12].bought == false) {
      t = products[12].price;
      p = [(products[12])]
    }
    setChooseProduct(p)
    setTotalPrice(t)
  }
  useEffect(() => {
    Axios.post(Config.api + "Product/GetProducts", {
      categoryIds: ["5ffcd4bf4e27702fc4f868db", "5fff7611022f0000100044c5"],
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: "Bearer " + localStorage.getItem('token')
        }

      }).then(async (result) => {
        setLoading(false)
        var s = state;
        result.data.data.forEach(element => {

          if (element._id == "5ffcde0ea50731301591cf3c" && element.bought)
            s.iranitex = true;
          else if (element._id == "5ffcde2570f81e3045f001f0" && element.bought) {
            setGoldValid(false)
            s.itweekend = true;
          }
          else if (element._id == "5fff62d9022f0000100044c2" && element.bought) {
            setGoldValid(false)
            s.startuptalent = true;
          }
          else if (element._id == "5fff6932022f0000100044c3" && element.bought) {
            setGoldValid(false)
            s.classes = true;
          }
          else if (element._id == "5fff759b022f0000100044c4" && element.bought) {
            setGoldValid(false)
            s.class1 = true;
          }
          else if (element._id == "5fff8c4aa35f000051003eb2" && element.bought) {
            setGoldValid(false)
            s.class2 = true;
          }
          else if (element._id == "5fff8c5aa35f000051003eb3" && element.bought) {
            setGoldValid(false)
            s.class3 = true;
          }
          else if (element._id == "600151e1a35f000051003eb6" && element.bought) {
            setGoldValid(false)
            s.class4 = true;
          }
          else if (element._id == "600151fba35f000051003eb7" && element.bought) {
            setGoldValid(false)
            s.class5 = true;
          }
          else if (element._id == "60015206a35f000051003eb8" && element.bought) {
            setGoldValid(false)
            s.class6 = true;
          }
          else if (element._id == "60015212a35f000051003eb9" && element.bought) {
            setGoldValid(false)
            s.class7 = true;
          }
          else if (element._id == "6001521fa35f000051003eba" && element.bought) {
            setGoldValid(false)
            s.class8 = true;
          }

          else if (element._id == "60015fb0a35f000051003ebb" && element.bought) {
            s.gold = true;
            s.iranitex = true;
            s.startuptalent = true;
            s.itweekend = true;
            s.classes = true;
            s.class1 = true;
            s.class2 = true;
            s.class3 = true;
            s.class4 = true;
            s.class5 = true;
            s.class6 = true;
            s.class7 = true;
            s.class8 = true;
          }
        });
        setState(s)
        setProducts(result.data.data);
      }).catch((err) => {
        setLoading(false)
        if (err && err.response && err.response.status && err.response.status === 401) {
          localStorage.removeItem('token');
          props.history.push("/SignIn");
        }
        else if (err && err.response && err.response.status && err.response.status === 422)
          swal("اطلاعات ارسالی نادرست است.");
        else if (err && err.response && err.response.status && err.response.status === 409) {
          swal("اطلاعات ارسالی نادرست است.");
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
          swal(err.response.data.message.pr);
        else swal("خطایی رخ داده است.")
      })

  }, []);

  return (
    <div>
      <Header
        color="transparent"
        brand="sharifcamp"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/bg9.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.top}>
                  <div>
                    <img src={logo} alt="..." className={imageClasses} />
                  </div>
                  <div className={classes.name}>
                    <h3 className={classes.title}>نمایشگاه ایران ایتکس</h3>
                    <h6>نخستین نمایشگاه مجازی فناوری اطلاعات و ارتباطات کشور</h6>
                    <h6>تاریخ برگزاری : 25 بهمن الی 5 اسفندماه 99</h6>
                    <br />
                    <div className={classes.justify}>
                      <p>
                        نمایشگاه ایران ایتکس نخستین نمایشگاه مجازی در حوزه کسب و کار های مبتنی بر فناوری اطلاعات می باشد که با شبیه سازی سه بعدی فضاهای مختلف، امکان ارائه محصولات و خدمات بر بستر فضای مجازی را برای شرکت ها، سازمان ها فراهم می کند.
                </p>
                      <p>
                        همچنین نمایشگاه ایران ایتکس در حوزه شناسایی افراد و استارتاپ های توانمند در حوزه ICT و برقراری ارتباط آن ها با مجموعه های فعال در حوزه مذکور فعالیت می کند
</p>
                      <p>
                        لازم به ذکر است امکان ارائه فرصت های شغلی برای کارفرمایان و ارسال رزومه کاری و استخدام در شرکت های بزرگ برای بازدیدکنندگان فراهم شده است.
</p>
                      <p>
                        در این نمایشگاه محصولات و خدمات مختلف شرکت ها به راحتی و با کمترین هزینه و زمان به علاقمندان در کشور عرضه می گردد و فرصتی خوبی برای تبادل نظرات و پیشنهادات برای شرکت کنندگان ایجاد می شود.
</p>
                      <p>
                        علاوه بر این در حاشیه این نمایشگاه، کارگاه­های آموزشی مختلف، جشنواره فناوری اطلاعات و مسابقات استعدادیابی استارتاپ ها به صورت مجازی برگزار می شد.
                </p>
                    </div>
                    <br />
                    <p>
                    <Button variant="contained" onClick={Go} color="secondary" >
                                ورود سریع به نمایشگاه
                        </Button>
                        {" "}
                        <Button variant="contained" style={{display: "none"}} onClick={Scroll} variant="outlined" disableElevation>
                                ثبت نام رویداد های جانبی
                        </Button>
                        {" "}
                    <Button variant="outlined" target='_blank' href="http://iranitex.com"  disableElevation>
                                         اطلاعات تکمیلی نمایشگاه ایران ایتکس
                                    </Button>
                                    </p>
                  </div>
                </div>
              </GridItem>

              <GridItem id="registerList" style={{display: "none"}} xs={12} sm={12} md={12} className={classes.navWrapper}>
                <Paper variant="outlined" className={classes.fastAccess + " " + classes.header + " " + classes.center} >
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12} className={classes.center + " " + classes.tableTitle}>
                      مدل های ثبت نام در رویداد
              </GridItem>
                    <GridItem xs={12} sm={12} md={1} >
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2} >
                      نام رویداد
              </GridItem>
                    <GridItem xs={12} sm={12} md={6} >
                      شرح خدمات
              </GridItem>
                    <GridItem xs={12} sm={12} md={3} >
                      مبلغ
              </GridItem>
                  </GridContainer>
                </Paper>
              </GridItem>
              <GridItem style={{display: "none"}} xs={12} sm={12} md={12}>
                <div className={classes.center + " " + classes.fastAccess}>
                  <BeatLoader loading={loading} color={"gray"} size={15} />
                </div>
                {(products) ?
                  <div>
                    <Paper variant="outlined" className={classes.fastAccess} >
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={1}>

                          <Checkbox
                            name={"iranitext"}
                            checked={state.iranitex}
                            onChange={(e) => { handleCheckBox(e) }}
                            disabled={products[0].price == 0 || state.gold || products[0].bought ? true : false}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />

                        </GridItem>
                        <GridItem xs={12} sm={12} md={2}>
                          <img className={classes.productLogo} src={products[0].logo} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <Typography className={classes.title} color="textSecondary" gutterBottom>
                            {products[0].title}
                          </Typography>
                          {products[0].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3} className={classes.center}>
                          <Typography className={classes.price} variant="body2" color="textSecondary" gutterBottom>
                            {products[0].price == 0 ? "رایگان" : products[0].price < 0 ? "" : products[0].price + " تومان"}
                          </Typography>
                        </GridItem>


                      </GridContainer>
                    </Paper>
                    <Paper variant="outlined" className={classes.fastAccess} >
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={1}>

                          <Checkbox
                            name={"itweekend"}
                            checked={state.itweekend}
                            onChange={(e) => { handleCheckBox(e) }}
                            disabled={products[1].price == 0 || state.gold || products[1].bought ? true : false}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />

                        </GridItem>
                        <GridItem xs={12} sm={12} md={2}>
                          <img className={classes.productLogo} src={products[1].logo} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <Typography className={classes.title} color="textSecondary" gutterBottom>
                            {products[1].title}
                          </Typography>
                          {products[1].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3} className={classes.center}>
                          <Typography className={classes.price} variant="body2" color="textSecondary" gutterBottom>
                            {products[1].price == 0 ? "رایگان" : products[1].price < 0 ? "" : products[1].price + " تومان"}
                          </Typography>
                        </GridItem>


                      </GridContainer>
                    </Paper>
                    <Paper variant="outlined" className={classes.fastAccess} >
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={1}>

                          <Checkbox
                            name={"startuptalent"}
                            checked={state.startuptalent}
                            onChange={(e) => { handleCheckBox(e) }}
                            disabled={products[2].price == 0 || state.gold || products[2].bought ? true : false}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />

                        </GridItem>
                        <GridItem xs={12} sm={12} md={2}>
                          <img className={classes.productLogo} src={products[2].logo} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <Typography className={classes.title} color="textSecondary" gutterBottom>
                            {products[2].title}
                          </Typography>
                          {products[2].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3} className={classes.center}>
                          <Typography className={classes.price} variant="body2" color="textSecondary" gutterBottom>
                            {products[2].price == 0 ? "رایگان" : products[2].price < 0 ? "" : products[2].price + " تومان"}
                          </Typography>
                        </GridItem>
                      </GridContainer>
                    </Paper>
                    <Paper variant="outlined" className={classes.fastAccess} >
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={1}>

                          <Checkbox
                            name={"classes"}
                            checked={state.classes}
                            onChange={(e) => { handleCheckBox(e) }}
                            disabled={products[3].price == 0 || state.gold || products[3].bought ? true : false}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />

                        </GridItem>
                        <GridItem xs={12} sm={12} md={2}>
                          <img className={classes.productLogo} src={products[3].logo} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <Typography className={classes.title} color="textSecondary" gutterBottom>
                            {products[3].title}
                          </Typography>
                          {products[3].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3} className={classes.center}>
                          <Typography className={classes.price} variant="body2" color="textSecondary" gutterBottom>
                            {products[3].price == 0 ? "رایگان" : products[3].price < 0 ? "" : products[3].price + " تومان"}
                          </Typography>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <Accordion elevation={0}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-label="Expand"
                              aria-controls="additional-actions1-content"
                              id="additional-actions1-header"
                            >
                              <div className={classes.column}>
                                <GridContainer >
                                  <GridItem xs={12} sm={12} md={1}>
                                    {
                                      products[4].price >= 0 ? (
                                        <Checkbox
                                          name={"class1"}
                                          checked={state.class1}
                                          disabled={products[4].price == 0 || state.gold || products[4].bought ? true : false}
                                          onChange={(e) => { handleCheckBox(e) }}
                                          onClick={(event) => event.stopPropagation()}
                                          onFocus={(event) => event.stopPropagation()}
                                          inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                      ) : null
                                    }
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={9}>
                                    <div className={classes.columnItem}>
                                      {products[4].title}
                                    </div>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={2}>
                                    <div className={classes.columnItem}>
                                      {products[4].price == 0 ? "رایگان" : products[4].price < 0 ? "" : products[4].price + " تومان"}
                                    </div>
                                  </GridItem>
                                </GridContainer>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography color="textSecondary">
                                {products[4].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion elevation={0}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-label="Expand"
                              aria-controls="additional-actions1-content"
                              id="additional-actions1-header"
                            >
                              <div className={classes.column}>
                                <GridContainer >
                                  <GridItem xs={12} sm={12} md={1}>
                                    {
                                      products[5].price >= 0 ? (
                                        <Checkbox
                                          name={"class2"}
                                          checked={state.class2}
                                          disabled={products[5].price == 0 || state.gold || products[5].bought ? true : false}
                                          onChange={(e) => { handleCheckBox(e) }}
                                          onClick={(event) => event.stopPropagation()}
                                          onFocus={(event) => event.stopPropagation()}
                                          inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                      ) : null
                                    }
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={9}>
                                    <div className={classes.columnItem}>
                                      {products[5].title}
                                    </div>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={2}>
                                    <div className={classes.columnItem}>
                                      {products[5].price == 0 ? "رایگان" : products[5].price < 0 ? "" : products[5].price + " تومان"}
                                    </div>
                                  </GridItem>
                                </GridContainer>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography color="textSecondary">
                                {products[5].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion elevation={0}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-label="Expand"
                              aria-controls="additional-actions1-content"
                              id="additional-actions1-header"
                            >
                              <div className={classes.column}>
                                <GridContainer >
                                  <GridItem xs={12} sm={12} md={1}>
                                    {
                                      products[6].price >= 0 ? (
                                        <Checkbox
                                          name={"class3"}
                                          checked={state.class3}
                                          disabled={products[6].price == 0 || state.gold || products[6].bought ? true : false}
                                          onChange={(e) => { handleCheckBox(e) }}
                                          onClick={(event) => event.stopPropagation()}
                                          onFocus={(event) => event.stopPropagation()}
                                          inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                      ) : null
                                    }
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={9}>
                                    <div className={classes.columnItem}>
                                      {products[6].title}
                                    </div>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={2}>
                                    <div className={classes.columnItem}>
                                      {products[6].price == 0 ? "رایگان" : products[6].price < 0 ? "" : products[6].price + " تومان"}
                                    </div>
                                  </GridItem>
                                </GridContainer>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography color="textSecondary">
                                {products[6].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                              </Typography>
                            </AccordionDetails>
                          </Accordion>



                          <Accordion elevation={0}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-label="Expand"
                              aria-controls="additional-actions1-content"
                              id="additional-actions1-header"
                            >
                              <div className={classes.column}>
                                <GridContainer >
                                  <GridItem xs={12} sm={12} md={1}>
                                    {
                                      products[7].price >= 0 ? (
                                        <Checkbox
                                          name={"class4"}
                                          checked={state.class4}
                                          disabled={products[7].price == 0 || state.gold || products[7].bought ? true : false}
                                          onChange={(e) => { handleCheckBox(e) }}
                                          onClick={(event) => event.stopPropagation()}
                                          onFocus={(event) => event.stopPropagation()}
                                          inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                      ) : null
                                    }
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={9}>
                                    <div className={classes.columnItem}>
                                      {products[7].title}
                                    </div>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={2}>
                                    <div className={classes.columnItem}>
                                      {products[7].price == 0 ? "رایگان" : products[7].price < 0 ? "" : products[7].price + " تومان"}
                                    </div>
                                  </GridItem>
                                </GridContainer>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography color="textSecondary">
                                {products[7].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                              </Typography>
                            </AccordionDetails>
                          </Accordion>


                          <Accordion elevation={0}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-label="Expand"
                              aria-controls="additional-actions1-content"
                              id="additional-actions1-header"
                            >
                              <div className={classes.column}>
                                <GridContainer >
                                  <GridItem xs={12} sm={12} md={1}>
                                    {
                                      products[8].price >= 0 ? (
                                        <Checkbox
                                          name={"class5"}
                                          checked={state.class5}
                                          disabled={products[8].price == 0 || state.gold || products[8].bought ? true : false}
                                          onChange={(e) => { handleCheckBox(e) }}
                                          onClick={(event) => event.stopPropagation()}
                                          onFocus={(event) => event.stopPropagation()}
                                          inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                      ) : null
                                    }
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={9}>
                                    <div className={classes.columnItem}>
                                      {products[8].title}
                                    </div>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={2}>
                                    <div className={classes.columnItem}>
                                      {products[8].price == 0 ? "رایگان" : products[8].price < 0 ? "" : products[8].price + " تومان"}
                                    </div>
                                  </GridItem>
                                </GridContainer>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography color="textSecondary">
                                {products[8].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                              </Typography>
                            </AccordionDetails>
                          </Accordion>


                          <Accordion elevation={0}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-label="Expand"
                              aria-controls="additional-actions1-content"
                              id="additional-actions1-header"
                            >
                              <div className={classes.column}>
                                <GridContainer >
                                  <GridItem xs={12} sm={12} md={1}>
                                    {
                                      products[9].price >= 0 ? (
                                        <Checkbox
                                          name={"class6"}
                                          checked={state.class6}
                                          disabled={products[9].price == 0 || state.gold || products[9].bought ? true : false}
                                          onChange={(e) => { handleCheckBox(e) }}
                                          onClick={(event) => event.stopPropagation()}
                                          onFocus={(event) => event.stopPropagation()}
                                          inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                      ) : null
                                    }
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={9}>
                                    <div className={classes.columnItem}>
                                      {products[9].title}
                                    </div>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={2}>
                                    <div className={classes.columnItem}>
                                      {products[9].price == 0 ? "رایگان" : products[9].price < 0 ? "" : products[9].price + " تومان"}
                                    </div>
                                  </GridItem>
                                </GridContainer>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography color="textSecondary">
                                {products[9].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                              </Typography>
                            </AccordionDetails>
                          </Accordion>


                          <Accordion elevation={0}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-label="Expand"
                              aria-controls="additional-actions1-content"
                              id="additional-actions1-header"
                            >
                              <div className={classes.column}>
                                <GridContainer >
                                  <GridItem xs={12} sm={12} md={1}>
                                    {
                                      products[10].price >= 0 ? (
                                        <Checkbox
                                          name={"class7"}
                                          checked={state.class7}
                                          disabled={products[10].price == 0 || state.gold || products[10].bought ? true : false}
                                          onChange={(e) => { handleCheckBox(e) }}
                                          onClick={(event) => event.stopPropagation()}
                                          onFocus={(event) => event.stopPropagation()}
                                          inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                      ) : null
                                    }
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={9}>
                                    <div className={classes.columnItem}>
                                      {products[10].title}
                                    </div>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={2}>
                                    <div className={classes.columnItem}>
                                      {products[10].price == 0 ? "رایگان" : products[10].price < 0 ? "" : products[10].price + " تومان"}
                                    </div>
                                  </GridItem>
                                </GridContainer>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography color="textSecondary">
                                {products[10].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                              </Typography>
                            </AccordionDetails>
                          </Accordion>


                          <Accordion elevation={0}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-label="Expand"
                              aria-controls="additional-actions1-content"
                              id="additional-actions1-header"
                            >
                              <div className={classes.column}>
                                <GridContainer >
                                  <GridItem xs={12} sm={12} md={1}>
                                    {
                                      products[11].price >= 0 ? (
                                        <Checkbox
                                          name={"class8"}
                                          checked={state.class8}
                                          disabled={products[11].price == 0 || state.gold || products[11].bought ? true : false}
                                          onChange={(e) => { handleCheckBox(e) }}
                                          onClick={(event) => event.stopPropagation()}
                                          onFocus={(event) => event.stopPropagation()}
                                          inputProps={{ 'aria-label': 'primary checkbox' }}
                                        />
                                      ) : null
                                    }
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={9}>
                                    <div className={classes.columnItem}>
                                      {products[11].title}
                                    </div>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={2}>
                                    <div className={classes.columnItem}>
                                      {products[11].price == 0 ? "رایگان" : products[11].price < 0 ? "" : products[11].price + " تومان"}
                                    </div>
                                  </GridItem>
                                </GridContainer>
                              </div>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography color="textSecondary">
                                {products[11].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </GridItem>

                      </GridContainer>
                    </Paper>
                    <Paper variant="outlined" className={classes.fastAccess} >
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={1}>
                          <Checkbox
                            name={"gold"}
                            checked={state.gold}
                            onChange={(e) => { handleCheckBox(e) }}
                            disabled={products[12].price == 0 || !goldValid || products[12].bought ? true : false}
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={2}>
                          <img className={classes.productLogo} src={products[12].logo} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <Typography className={classes.title} color="textSecondary" gutterBottom>
                            {products[12].title}
                          </Typography>
                          {products[12].summary.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={3} className={classes.center}>
                          <Typography className={classes.price} variant="body2" color="textSecondary" gutterBottom>
                            {products[12].price == 0 ? "رایگان" : products[12].price < 0 ? "" : products[12].price + " تومان"}
                          </Typography>
                        </GridItem>
                      </GridContainer>
                    </Paper>
                    <Paper variant="outlined" className={classes.fastAccess} >
                      <GridContainer>

                        <GridItem xs={12} sm={12} md={12} className={classes.center}>
                          <div className={classes.totalPrice}>مبلغ قابل پرداخت: {totalPrice} تومان</div>
                          <div className={classes.pay}>
                            {totalPrice == 0 ? (
                              <Button variant="contained" onClick={Go} color="primary">
                                ورود به نمایشگاه
                              </Button>
                            ) : (
                                <div>
                                  <form className={classes.root} noValidate autoComplete="off">
                                    <TextField id="standard-basic" value={state.offCode} onChange={handleTextBoxChange} label="کد تخفیف" />
                                  </form>
                                  <Button variant="contained" onClick={PayAndGo} color="primary">
                                    پرداخت و ورود به نمایشگاه
                                </Button>
                                </div>
                              )
                            }
                          </div>
                        </GridItem>
                      </GridContainer>
                    </Paper>

                    <Paper variant="outlined" className={classes.fastAccess} >
                      <GridContainer>

                        <GridItem xs={12} sm={12} md={12} className={classes.fastAccess + " " + classes.description} >

                          <p>
                            توضیحات:
                        </p>
                          <p>
                            <ul>
                              <li>
                                دانشجویان با ارائه کارت دانشجویی معتبر می توانند با 50 درصد تخفیف در رویداد ها ثبت نام کنند
                               </li>
                              <li>
                                استارتاپ هایی که در رویداد استارتاپ تلنت ثبت نام کردند، در صورتی که موردپذیرش تیم داوری قرار بگیرند، می توانند با 50 درصد تخفیف در رویداد ها ثبت نام کنند
                               </li>
                              <li>
                                در صورت ثبت نام گروهی 5 نفر به بالا، 20 درصد تخفیف ارائه خواهد شد.
                               </li>
                              <li>
                                شرکت های غرفه دار در نمایشگاه ایران ایتکس، می توانند با 50 درصد تخفیف در رویداد ها ثبت نام کنند.
                               </li>
                            </ul>
                          </p>
                        </GridItem>
                      </GridContainer>
                    </Paper>


                  </div>
                  : null
                }
              </GridItem>
            </GridContainer>
            <div className={classes.description}>
              <p>
                {" "}
              </p>
            </div>
            <GridContainer justify="center">
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
